import { Stack } from '@mui/material'
import Drawer from '@mui/material/Drawer'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { isOperator } from '../../../../services/AccountService'
import ContentTitle from './components/ContentTitle'
import DrawerHeader from './components/DrawerHeader'
import EquipmentDataSection from './components/EquipmentDataSection'
import ToServiceActionButtons from './components/ToServiceActionButtons'
import { contentWrapperSx } from './consts/styles.consts'
import { useNewServiceResultsDrawer } from './hooks/useNewServiceResultsDrawer'
import { createServiceRequestStore } from './stores/NewCreateServiceRequestStore'

interface NewServiceResultsDrawerProps {
  serviceStore: any
}

export type Mode = 'default' | 'has-active' | 'has-closed' | 'checked'

const NewServiceResultsDrawer: FC<NewServiceResultsDrawerProps> = ({
  serviceStore,
}) => {
  const { diagnosticData, fromExistedRequest, isServerOrdersDrawerOpen } =
    createServiceRequestStore

  const {
    onClose,
    handleSubmit,
    onSubmit,
    control,
    watch,
    mode,
    serialResponse,
    selectedServiceRequest,
    onBack,
    openedAccordionIndex,
    setOpenedAccordionIndex,
    getOnCheck,
    isValid,
    isSending,
    isLinking,
    isCreating,
    showContinueBtn,
    checked,
    serialNum,
    errors,
    isPending,
    onSendExistedRequest,
    linkToServiceRequest,
    createWithLinkToServiceRequest,
    setMode,
    onSerialErrorBtn,
    onSerialCheck,
    serialResponseError,
  } = useNewServiceResultsDrawer(serviceStore)

  return (
    <Drawer
      anchor={'right'}
      open={isServerOrdersDrawerOpen}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: 380,
        },
      }}
    >
      <DrawerHeader
        title={`Заявка на ${!isOperator() ? 'обслуживание' : 'ремонт'}`}
        onBack={onBack}
        onClose={onClose}
      />
      <Stack
        sx={contentWrapperSx}
        spacing={'14px'}
        justifyContent={'space-between'}
        component={'form'}
        onSubmit={handleSubmit(onSubmit)}
      >
        <Stack spacing={'14px'} marginBottom={'14px !important'}>
          <ContentTitle
            styles={{ margin: '0 0 8px 0 !important' }}
            title={'Проверка серийного номера'}
          />
          <EquipmentDataSection
            control={control}
            watch={watch}
            mode={mode}
            serialResponse={serialResponse}
            selectedServiceRequest={selectedServiceRequest}
            openedAccordionIndex={openedAccordionIndex}
            setOpenedAccordionIndex={setOpenedAccordionIndex}
            getOnCheck={getOnCheck}
          />
        </Stack>

        <ToServiceActionButtons
          mode={mode}
          fromExistedRequest={fromExistedRequest}
          isValid={isValid}
          isSending={isSending}
          isLinking={isLinking}
          isCreating={isCreating}
          selectedServiceRequest={selectedServiceRequest}
          showContinueBtn={showContinueBtn}
          checked={checked}
          diagnosticData={diagnosticData}
          serialResponse={serialResponse}
          serialNum={serialNum}
          errors={errors}
          isPending={isPending}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          onSendExistedRequest={onSendExistedRequest}
          linkToServiceRequest={linkToServiceRequest}
          createWithLinkToServiceRequest={createWithLinkToServiceRequest}
          setMode={setMode}
          onSerialErrorBtn={onSerialErrorBtn}
          onSerialCheck={onSerialCheck}
          onBack={onBack}
          serialResponseError={serialResponseError}
        />
      </Stack>
    </Drawer>
  )
}

export default observer(NewServiceResultsDrawer)
